import React, { Component } from "react";
import PropTypes from "prop-types";
import Table from "../../common/table/Table";
import { Link } from "react-router";
import * as types from "../dashboardActionTypes";
import WidgetErrorMessage from "./WidgetErrorMessage";
import WidgetReloader from "./WidgetReloader";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../dashboardActions";
import {
  getDeviceGroups,
  getDeviceGroupsIsLoading
} from "../dashboardSelector";
import LogsSourceWidgetTableRow from "./LogsSourceWidgetTableRow";
import LogsSourceWidgetTableRowShowMore from "./LogsSourceWidgetTableRowShowMore";
import Spinner from "../../common/progress/Spinner";
import Widget from "./Widget";
import LogsSourceStatusWidgetTable from "./LogsSourceStatusWidgetTable";
import translate from "react-i18next/dist/commonjs/translate";
import WidgetOverlayLinkToTa from "./WidgetOverlayLinkToTa";
import MockData from "./deviceGroupsMockData";

export class LogSourceStatusWidget extends Component {
  constructor(props) {
    super(props);
    this.onReload = this.onReload.bind(this);
  }

  componentDidMount() {
      if (this.props.customerInformation.siem != "wazuh") {
          this.props.actions.loadDeviceGroups();
      }
  }

  onReload() {
      if (this.props.customerInformation.siem != "wazuh") {
          this.props.actions.loadDeviceGroups();
      }
  }

  render() {
    const { customerInformation,deviceGroups, isLoading, errors, t } = this.props;
    const deviceGroupsError = errors.filter(
      err => err.key === types.LOAD_DEVICE_GROUPS_FAILED
    );
    const hasErrors = deviceGroupsError.length > 0;
    const errorMessage = hasErrors ? deviceGroupsError[0].message : "";


      if (customerInformation.siem === "wazuh") {
          return (
              <Widget
                  header={t("logSourceWidgetTitle")}
                  onReload={this.onReload}
              >
                  <WidgetOverlayLinkToTa buttonText={t("logInToTa")} taUrl={customerInformation.technicalAnalysisUrl} />
                  <LogsSourceStatusWidgetTable deviceGroups={MockData} />
              </Widget>
          );
      }

    if (isLoading) {
      return (
        <Widget
          header={t("logSourceWidgetTitle")}
          onReload={this.onReload}
          isLoading={isLoading}
        >
          <div className="pie-wrapper align-center">
            <div className="text-center">
              <Spinner />
            </div>
          </div>
        </Widget>
      );
    }
   
    if (hasErrors) {
      return (
        <Widget header={t("logSourceWidgetTitle")} onReload={this.onReload}>
          <div className="overlay overlay-default">
            <WidgetErrorMessage onClick={this.onReload} />
          </div>
        </Widget>
      );
    }
    return (
      <Widget header={t("logSourceWidgetTitle")} onReload={this.onReload}>
        <LogsSourceStatusWidgetTable deviceGroups={deviceGroups} />
      </Widget>
    );
  }
}

LogSourceStatusWidget.propTypes = {
  customerInformation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  deviceGroups: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired
    })
  )
};

const mapStateToProps = state => {
  return {
    deviceGroups: getDeviceGroups(state),
    isLoading: getDeviceGroupsIsLoading(state),
    errors: state.errors,
    customerInformation: state.customerInformation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LogSourceStatusWidget)
);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/LogsSourceStatusWidget.js